import React, { useState } from "react";
import "./Contact.css";
import lady from "../../Images/Contact/ContactGirl.png";
import Indiagate from "../../Images/Contact/Indiagate.png";
import Buddha from "../../Images/Contact/Buddha.png";
import map from "../../Images/Contact/map.png";
import SendMsg from "../../Images/Contact/SendMsg.png";
import HeroSlideBtn from "../../GlobalComponents/HeroSlideBtn/HeroSlideBtn";
import aargus_noida from "../../Images/Contact/aargus_noida.png";

const GOOGLE_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbxo7hzA3mEEr7nX7B3Et1A2plTdO1HRQE547n2SPuyo4HAxEZ--Rs8JRhNAcCVjTPCY/exec";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    const name = formData.name.trim();
    const email = formData.email.trim();
    const message = formData.message.trim();

    if (!name || !email || !message) {
      setStatus({ type: "error", text: "Please fill all fields." });
      return;
    }

    setLoading(true);
    setStatus({ type: "", text: "" });

    try {
      await fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify({ name, email, message }),
      });

      setStatus({
        type: "success",
        text: "Request sent. Please check your email for confirmation.",
      });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Submission error:", error);
      setStatus({
        type: "error",
        text: "Unable to send request. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* ----------------Contact Hero-------------------- */}
      <div className="Contact_Hero relative flex p-5 justify-center items-center  overflow-hidden">
        <div className=" w-[90%]  flex text-white justify-center text-center ">
          <h1 className=" text-[3rem] md:text-[5rem] font-semibold mb-28  ">
            How can we help you?
          </h1>
        </div>

        <div className=" absolute bottom-0 py-10 ">
          <HeroSlideBtn />
        </div>
      </div>

      <div className="w-[80%] flex flex-col gap-20 m-auto py-10">
        {/* ----------------Contact intro-------------------- */}
        <div className="flex justify-center items-center text-center px-1 md:px-20">
          <p>
            To gain a competitive advantage in today's fast-paced era, contact
            us immediately to explore the realm of possibilities and transform
            them into tangible achievements!
          </p>
        </div>

        {/* ----------------Address 1-------------------- */}
        <div className="flex flex-col sm:flex-row m-auto ">
          <div className="flex flex-col gap-5 justify-center items-center place-items-center ">
            <div className="flex justify-center">
              <img src={Indiagate} alt="Indiagate" className="w-[80%]" />
            </div>
            <h1 className="text-[2.5rem] font-bold text-[#047FCC] uppercase">
              Delhi
            </h1>
          </div>
          <div className="flex flex-col items-center">
            <div className="flex flex-col items-center   text-center mb-[3rem]">
              <h3 className="text-[2rem] font-semibold mb-10">
                Registered office
              </h3>
              <p className="px-[10%] sm:px-[25%]">
                S-3, Anupam Plaza, Opposite Azad Apartments, Sri Aurbindo Marg,
                Hauz Khas, New Delhi - 110016 <br />{" "}
                <span className="font-bold">Email:</span>{" "}
                mail@aargusinfotec.com <br />{" "}
                <span className="font-bold">Phone:</span>
                +91-11-41072677
              </p>
            </div>
            <div>
              <img src={map} alt="Indiagate" />
            </div>
          </div>
        </div>

        {/* ----------------Address 2-------------------- */}
        <div className="flex flex-col sm:flex-row-reverse m-auto ">
          <div className="flex flex-col gap-5 justify-center items-center place-items-center ">
            <div className="flex justify-center">
              <img src={Buddha} alt="Indiagate" className="w-[80%]" />
            </div>
            <h1 className="text-[2.5rem] font-bold text-[#047FCC] uppercase">
              Noida
            </h1>
          </div>
          <div className="flex flex-col items-center">
            <div className="flex flex-col items-center   text-center mb-[3rem]">
              <h3 className="text-[2rem] font-semibold mb-10">
                corporate office
              </h3>
              <p className="px-[10%] sm:px-[20%]">
                605, Tower A, The I-Thum, Plot No. A-40, Sector-62, Noida
                (U.P.) - 201309 <br />{" "}
                <span className="font-bold">Email:</span>{" "}
                mail@aargusinfotec.com <br />{" "}
                <span className="font-bold">Phone:</span>
                +91-120-4511090
              </p>
            </div>
            <div>
              <img
                src={aargus_noida}
                alt="Indiagate"
                style={{ width: "500px", height: "210px" }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* ----------------Let's talk-------------------- */}
      <div className="LetsTalk flex justify-center items-center p-5">
        <div className="flex w-[95%] sm:w-[80%] lg:w-[70%]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 m-auto items-center w-full bg-white px-6 py-10 md:px-10 rounded-3xl shadow-2xl overflow-hidden">
            {/* Form */}
            <div className="FormContainer w-full">
              <h1 className="text-[2rem] font-bold text-gray-900">Let’s talk</h1>
              <p className="text-gray-500 mt-1 mb-6 text-sm">
                Tell us a bit about your requirement and we’ll get back to you soon.
              </p>

              <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="name" className="text-sm font-medium text-gray-700">
                    Your Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="John Doe"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full rounded-xl border border-gray-300 bg-gray-50 px-4 py-3 text-gray-900 placeholder-gray-400 outline-none transition focus:border-[#047FCC] focus:bg-white focus:ring-4 focus:ring-[#047FCC]/15"
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label htmlFor="email" className="text-sm font-medium text-gray-700">
                    Your Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="you@company.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full rounded-xl border border-gray-300 bg-gray-50 px-4 py-3 text-gray-900 placeholder-gray-400 outline-none transition focus:border-[#047FCC] focus:bg-white focus:ring-4 focus:ring-[#047FCC]/15"
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label htmlFor="msg" className="text-sm font-medium text-gray-700">
                    Your Message
                  </label>
                  <textarea
                    id="msg"
                    name="message"
                    rows="4"
                    placeholder="How can we help you?"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    className="w-full resize-none rounded-xl border border-gray-300 bg-gray-50 px-4 py-3 text-gray-900 placeholder-gray-400 outline-none transition focus:border-[#047FCC] focus:bg-white focus:ring-4 focus:ring-[#047FCC]/15"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="flex items-center justify-center gap-2 w-full rounded-xl bg-[#047FCC] px-6 py-3 font-semibold text-white shadow-lg shadow-[#047FCC]/30 transition hover:bg-[#0369a8] hover:-translate-y-0.5 active:translate-y-0 disabled:cursor-not-allowed disabled:opacity-70 disabled:hover:translate-y-0"
                >
                  {loading && (
                    <svg
                      className="h-5 w-5 animate-spin"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      />
                    </svg>
                  )}
                  {loading ? "Sending..." : "Send Message"}
                </button>

                {status.text && (
                  <div
                    role="status"
                    className={`rounded-xl border px-4 py-3 text-sm ${status.type === "success"
                        ? "border-green-200 bg-green-50 text-green-700"
                        : "border-red-200 bg-red-50 text-red-700"
                      }`}
                  >
                    {status.text}
                  </div>
                )}
              </form>
            </div>

            {/* Image */}
            <div className="hidden md:flex justify-center">
              <img src={SendMsg} alt="SendMsg" className="w-[85%]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;